module.exports = __webpack_public_path__ + "static/media/dineInDinner.a8371a7e.pdf";